module.exports = __webpack_public_path__ + "img/default-account.9ffa8d1d.png";